import { useEffect, FunctionComponent } from 'react'

import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import classNames from 'classnames'
import { notifyRender } from 'front-end-core/services/WindowService'
import { updateBreakpoints } from 'services/AccordionService'
import GroupListItemContainer from 'redux/containers/components/accordion/GroupListItemContainer'
import useBaseState from 'hooks/useBaseState'
import { GroupContainerProps } from 'redux/containers/components/accordion/GroupContainer'
import { AccordionGroup } from 'interfaces/accordion'

const Group:FunctionComponent<GroupProps> = (props) => {
  const { baseState } = useBaseState<GroupBaseState>(props.state, {
    expanded: 0,
    display: 1,
    group: RESPONSE_PENDING,
    enableHighlight: 1
  })

  useEffect(() => {
    updateBreakpoints()
    notifyRender(props.id)
  }, [])

  if (!baseState.display || props.disabled) return null

  const expanded = baseState.expanded > 0
  const isLoading = baseState.expanded && baseState.group === RESPONSE_PENDING

  const className = classNames({
    'has-children': true,
    'is-loading': isLoading,
    disabled: props.disabled,
    [`depth-${props.depth}`]: true,
    [props.className]: true,
    'scroll-adjust': expanded && !isLoading,
    highlight: baseState.enableHighlight && props.id === props.highlight
  })

  return (
    <GroupListItemContainer
      state={baseState}
      {...{ props, expanded, isLoading, className }}
    />
  )
}

export interface GroupProps extends GroupContainerProps{
  state?: any; //FIX ME some kind of a global state couldn't find the source
  disabled: boolean;
  id:string;
  depth: number;
  className: string;
}

export interface GroupBaseState {
  expanded: number;
  display: number;
  group: number | AccordionGroup[];
  enableHighlight: number
}

export default Group
